import React, { cloneElement, useEffect } from "react";
import RagnaWindow from  "./RagnaWindow";

const RagnaModal = props => {
    const noBackdropClose = props.noBackdropClose ?? false;
	const CustomTrigger = _ => props.customTrigger !== undefined ?
		(cloneElement(props.customTrigger, {
			className: props.btnClass,
			onClick: _ => {
				//document.body.classList.add("modal-open");
				props.setModalOpen(true);
			}
		})) : null;

	useEffect(_ => {
		if (props.modalOpen && props.openAndThen) {
			props.openAndThen();
		}
	},[props.modalOpen])

	return (
		<div className={props.className}>
			<div className={props.btnContClass}>
				{
					props.noBtn ? <></> : (
						CustomTrigger() ? (
							<CustomTrigger />
						) :
							<button {...props.btnProps}
								className={props.btnClass ?? "ro-button"}
								onClick={_ => {
									if (props.syncFunction) props.syncFunction();
									//document.body.classList.add("modal-open");
									props.setModalOpen(true);
								}}
								style={(props.btnProps ? { pointerEvents: props.btnProps.disabled ? "none" : "initial"} : {})}
							>
							<span>{props.trigName ? props.trigName : "Open Modal"}</span>
						</button>
					)
				}
			</div>
			<div
				className={"rmodal-main " + (props.modalOpen ? "open" : "")}
				style={{ transition: "all .3s", opacity: props.modalOpen ? 1 : 0 }}
			>
				<div
					className="rmodal-backdrop"
					onClick={_ => {
						//document.body.classList.remove("modal-open");
						if (!noBackdropClose) {
							props.setModalOpen(false);
							if(props.closeAndThen) props.closeAndThen()
						}
					}}
					style={{ pointerEvents: props.modalOpen ? "initial" : "none" }}
				>
					<RagnaWindow
						boxStyle={props.boxStyle}
						mainStyle={props.mainStyle}
						onClick={e => {
							e.stopPropagation();
						}}
						className="rmodal-window"
						closeFunc={
							props.hideClose ? null :
							(_ => {
								//document.body.classList.remove("modal-open");
								props.setModalOpen(false);
								if (props.closeAndThen) props.closeAndThen();
							})
						}
						title={props.title}
						footer={props.footer}
						mainStyle={{
							maxWidth: props.width ? props.width : 400
						}}
					>
						{props.body}
					</RagnaWindow>
				</div>
			</div>
		</div>
	);
};


export default RagnaModal;